import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tab',
    template: `@if (isActive) {
        <ng-content></ng-content>
    }`,
    styles: [':host { display: block }'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TabComponent {
    @Input() public tabTitle: string;

    @Input() public tabCount?: number;

    public isActive: boolean = false;

    public setIsActive(isActive: boolean): void {
        this.isActive = isActive;
    }

    public getIsActive(): boolean {
        return this.isActive;
    }
}
